import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { User } from 'src/app/shared/user.model';
import { UserService } from 'src/app/shared/user.service';
import { Objective } from '../../models/objectives';
import { ObjectivesService } from '../../services/objectives.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { DatePipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { KeyresultStatusRowComponent } from '../../components/keyresult-status-row/keyresult-status-row.component';
import { TaskStatusRowComponent } from '../../components/task-status-row/task-status-row.component';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-new-checkin',
    templateUrl: './new-checkin.component.html',
    styleUrls: ['./new-checkin.component.css'],
    imports: [MatIcon, MatDivider, MatProgressBar, KeyresultStatusRowComponent, TaskStatusRowComponent, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, DatePipe]
})
export class NewCheckinComponent implements OnInit {

  Objective: Objective;
  ObjectiveId: string;
  users: User[];
  checkinForm;
  
  constructor(
    private fb: UntypedFormBuilder,
    private objectiveService: ObjectivesService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    ){
      
    }
    
   

  ngOnInit(): void {
    
    this.activatedRoute.params.subscribe(params => {
      
      this.ObjectiveId = params['ObjectiveId'];      
      this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
        this.Objective = data;
        this.userService.getAllUsers().subscribe(data=>{
          this.users =  data as User[];
        });

        this.checkinForm = this.fb.group({
          ObjectiveId: [this.Objective.ObjectiveId],
          CheckinDate: [new Date(), [Validators.required]],
          Owner: [this.Objective.Owner, [Validators.required]],   
          Status: [this.Objective.Status, [Validators.required]],
          Progress: [''],
          Impediments: [''],
          Initiatives: [''],
          Confidence: ['']                        
        });
      });
    });              
  }

  onSubmit(){
    console.log(this.checkinForm.value);
    this.objectiveService.addCheckin(this.checkinForm.value).subscribe(data=>{
      console.log(data);
      if(this.Objective.ObjectiveLevel=='ORGANIZATION')
        this.router.navigate(['/objectives/organization']);
      else
        this.router.navigate(['/objectives/team/' + this.Objective.TeamId]);
    });
  }

  goback():void{
    //this.router.navigate(['..']);
    window.history.back();
    
     // this.location.back()
    
  }

}
